import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { GameView, ViewToggle } from '@swf/poker';

import { useHomeGamesWidget } from '../../model';

import styles from './GameViewToggle.scss';

export interface Props {
  id: string;
}

const GameViewToggle: React.FC<Props> = ({ id }) => {
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const state =
    useSelector((rootState: RootState) =>
      widgetSelect.localStorageItem(rootState, `gameTileView[${id}]`)
    ) ?? GameView.Grid;

  const handleSelect = (newState: GameView) => {
    widgetDispatch.setLocalStorageItem({ gameTileView: { [id]: newState } });
  };

  return (
    <ViewToggle
      id={id}
      selected={state}
      handleSelect={handleSelect}
      classes={{
        container: styles.container,
        button: styles.button,
        active: styles.active
      }}
    />
  );
};
export default GameViewToggle;
